// 点选相关code配置
const POINT_SELETE_COLLECTION = ['system.Pickup']

// 移动相关code配置
const MOVE_COLLECTION = [
  'system.Move',
  'system.Rotate',
  'system.ToolFixedObservation',
  'system.Scale',
  'system.PickupCenter',
]

// 测量相关code配置
const MEASURE_COLLECTION = [
  'M_Line',
  'M_Point',
  'M_Vertical',
  'M_Stereo',
  'M_Angel',
  'M_Area',
  'M_WheelBase',
  'M_None',
]

// 漫游相关
const ROAM_COLLECTION = ['system.walk.first', 'system.walk.fixView']

// 互斥数据对象
const UNALLOW_COEXIST_COM = {
  // key: 互斥code， value 互斥操作 集合
  // ex:
  // system.Move : ['system.Rotate']
  AllClip: ['PartClipBox', 'ThreePanel', 'UnderClip'],
  PartClipBox: ['AllClip', 'ThreePanel', 'UnderClip'],
  ThreePanel: ['AllClip', 'PartClipBox', 'UnderClip'],
  UnderClip: ['AllClip', 'PartClipBox', 'ThreePanel'],
  BridgeCable: ['MetalBim'],
  MetalBim: ['BridgeCable'],
}

export {
  POINT_SELETE_COLLECTION,
  MOVE_COLLECTION,
  MEASURE_COLLECTION,
  UNALLOW_COEXIST_COM,
  ROAM_COLLECTION,
}
